import React, { useState } from "react";
import ReactDOM from "react-dom";
import { HiX, HiPlus, HiOutlineLink, HiOutlineInformationCircle } from "react-icons/hi";
import { toast } from "react-toastify";
import "../styles.css";

function ModalLicitacion({ onClose, onGuardar }) {
  const [nueva, setNueva] = useState({
    numero_expediente: "",
    boe: "",
    titulo: "",
    ambito: "",
    presupuesto: "",
    observaciones: "",
    clasificacion: "",
    procedimiento: "",
    organismo: "",
    fecha_presentacion: "",
    estado: "pendiente",
    medio: "",
    estudio_economico: "",
    resultado_apertura: "",
    pais: "",
    enlaces: ""
  });

  const [guardando, setGuardando] = useState(false);

  const handleChange = (campo, valor) =>
    setNueva((prev) => ({ ...prev, [campo]: valor }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!onGuardar) return;

    setGuardando(true);
    try {
      const enlacesItems = (nueva.enlaces || "")
        .split("\n")
        .map((l) => l.trim())
        .filter((l) => l.length > 0)
        .map((l) => {
          const [nombreRaw, urlRaw] = l.split(";", 2);
          const nombre = (nombreRaw || "").trim();
          const url = (urlRaw || "").trim();
          if (!url) return null;
          const nombreSafe = nombre.replace("|", " ").replace(";", ",");
          return `${nombreSafe};${url}`;
        })
        .filter(Boolean);

      const payload = {
        ...nueva,
        numero_expediente: nueva.numero_expediente.trim(),
        boe: nueva.boe || null,
        fecha_presentacion: nueva.fecha_presentacion || null,
        presupuesto: nueva.presupuesto ? parseFloat(nueva.presupuesto) : null,
        enlaces: enlacesItems.length ? enlacesItems : []
      };

      await onGuardar(payload);
      onClose();
    } catch (err) {
      console.error("Error guardando licitación:", err);
      toast.error("Error al guardar la licitación.");
    } finally {
      setGuardando(false);
    }
  };

  const modalContent = (
    <div className="modal-overlay">
      <div className="modal animate-fadeIn" style={{ maxWidth: '900px' }}>
        <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
          <h2 style={{ margin: 0 }}>Nueva Licitación</h2>
          <button className="btn-icon" onClick={onClose} style={{ background: 'transparent', border: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
            <HiX size={24} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="form-licitacion-modern">
          <div className="info-grid">
            <div className="form-group">
              <label>Número expediente *</label>
              <input
                type="text"
                value={nueva.numero_expediente}
                onChange={(e) => handleChange("numero_expediente", e.target.value)}
                required
                placeholder="EXP-202X-XX"
              />
            </div>

            <div className="form-group">
              <label>Fecha BOE</label>
              <input
                type="date"
                value={nueva.boe}
                onChange={(e) => handleChange("boe", e.target.value)}
              />
            </div>

            <div className="form-group full-width">
              <label>Título *</label>
              <input
                type="text"
                value={nueva.titulo}
                onChange={(e) => handleChange("titulo", e.target.value)}
                required
                placeholder="Título descriptivo de la licitación"
              />
            </div>

            <div className="form-group">
              <label>Ámbito</label>
              <input
                type="text"
                value={nueva.ambito}
                onChange={(e) => handleChange("ambito", e.target.value)}
                placeholder="Ej. Autonómico, Nacional..."
              />
            </div>

            <div className="form-group">
              <label>Presupuesto (Sin IVA)</label>
              <div className="input-with-icon" style={{ position: 'relative' }}>
                <input
                  type="number"
                  step="0.01"
                  value={nueva.presupuesto}
                  onChange={(e) => handleChange("presupuesto", e.target.value)}
                  placeholder="0.00"
                  style={{ paddingRight: '40px' }}
                />
                <span style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', color: 'var(--text-secondary)' }}>€</span>
              </div>
            </div>

            <div className="form-group">
              <label>Organismo</label>
              <input
                type="text"
                value={nueva.organismo}
                onChange={(e) => handleChange("organismo", e.target.value)}
                placeholder="Entidad contratante"
              />
            </div>

            <div className="form-group">
              <label>País</label>
              <input
                type="text"
                value={nueva.pais}
                onChange={(e) => handleChange("pais", e.target.value)}
                placeholder="España..."
              />
            </div>

            <div className="form-group">
              <label>Fecha presentación</label>
              <input
                type="date"
                value={nueva.fecha_presentacion}
                onChange={(e) => handleChange("fecha_presentacion", e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Estado</label>
              <select
                value={nueva.estado}
                onChange={(e) => handleChange("estado", e.target.value)}
              >
                <option value="pendiente">En curso</option>
                <option value="presentada">Presentada</option>
                <option value="proxima">Próxima</option>
                <option value="cerrada">Cerrada</option>
                <option value="adjudicada">Adjudicada</option>
                <option value="no adjudicada">No adjudicada</option>
              </select>
            </div>

            <div className="form-group full-width">
              <label>Observaciones / Garantía</label>
              <textarea
                value={nueva.observaciones}
                onChange={(e) => handleChange("observaciones", e.target.value)}
                rows={3}
                placeholder="Detalles adicionales..."
              />
            </div>

            <div className="form-group full-width">
              <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <HiOutlineLink /> Enlaces (Nombre;URL, uno por línea)
              </label>
              <textarea
                placeholder={"Pliego administrativo;http://...\nPliego técnico;http://..."}
                value={nueva.enlaces}
                onChange={(e) => handleChange("enlaces", e.target.value)}
                rows={4}
              />
            </div>
          </div>

          <div className="modal-footer" style={{ marginTop: '32px', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <button type="button" className="btn-gestion" onClick={onClose} style={{ color: 'var(--text-primary)' }}>
              Cancelar
            </button>
            <button type="submit" className="btn-nueva" disabled={guardando}>
              {guardando ? (
                "Guardando..."
              ) : (
                <>
                  <HiPlus /> Crear Licitación
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
}

export default ModalLicitacion;
